import { AddExerciseToPatientPayload, Exercise } from '_api/types';
import DefaultAddExerciseToPatientSettings from '_constants/object-templates/DefaultExerciseToPatientSettings';

export function buildExerciseSchedule(perWeek: number): string[] {
  switch (perWeek) {
    case 0:
      return [];
    case 1:
      return ['M'];
    case 2:
      return ['TU', 'TH'];
    case 3:
      return ['M', 'W', 'F'];
    case 4:
      return ['M', 'TU', 'TH', 'F'];
    case 5:
      return ['M', 'TU', 'W', 'TH', 'F'];
    case 6:
      return ['M', 'TU', 'W', 'TH', 'F', 'SA'];
    default:
      return ['M', 'TU', 'W', 'TH', 'F', 'SA', 'SU'];
  }
}

export function buildExercisePayload(
  id: number,
  patientId: number | '',
  exercise: Exercise | undefined,
): AddExerciseToPatientPayload {
  const { perDay, perWeek, regimenType, reps, sets, therapyType, ...rest } =
    DefaultAddExerciseToPatientSettings;
  const resolvedPerWeek = exercise?.defaultPerWeek ?? perWeek;

  return {
    ...rest,
    contentId: id,
    patientId,
    regimenType: exercise?.defaultExerciseDetail ?? regimenType,
    perDay: exercise?.defaultPerDay ?? perDay,
    perWeek: resolvedPerWeek,
    schedule: buildExerciseSchedule(resolvedPerWeek),
    reps: exercise?.defaultReps ?? reps,
    sets: exercise?.defaultSets ?? sets,
    therapyType: exercise?.defaultTherapyType ?? therapyType,
    defaultTargetSide: exercise?.targetSide?.name ?? 'NA',
    instructionList: [...(exercise?.instructionList ?? [])],
    description: exercise?.description ?? '',
  };
}
